(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@amp-metrics/mt-metricskit-utils-private'), require('@amp-metrics/mt-client-logger-core')) :
    typeof define === 'function' && define.amd ? define(['@amp-metrics/mt-metricskit-utils-private', '@amp-metrics/mt-client-logger-core'], factory) :
    (global = global || self, global.MTClientConfig = factory(global.mtMetricskitUtilsPrivate, global.mtClientLoggerCore));
}(this, (function (mtMetricskitUtilsPrivate, mtClientLoggerCore) { 'use strict';

    /*
     *  src/environment.js
     *  mt-client-config
     *
     *  Copyright © 2016-2017 Apple Inc. All rights reserved.
     *
     */

    var attachDelegate = mtMetricskitUtilsPrivate.reflect.attachDelegate;
    var localStorageObject = mtMetricskitUtilsPrivate.storage.localStorageObject;
    var sessionStorageObject = mtMetricskitUtilsPrivate.storage.sessionStorageObject;

    /**
     * Provides a set of environment-specific (platform-specific) functions which can be individually overridden for the needs
     * of the particular environment, or replaced en masse by providing a single replacement environment delegate object
     * The functionality in this class is typically replaced via a delegate.
     * @see setDelegate
     * @delegatable
     * @constructor
     */
    var environment = {
        /**
         ************************************ PUBLIC METHODS/IVARS ************************************
         */

        /**
         * Allows replacement of one or more of this class' functions
         * Any method on the passed-in object which matches a method that this class has will be called instead of the built-in class method.
         * To replace *all* methods of his class, simply have your delegate implement all the methods of this class
         * Your delegate can be a true object instance, an anonymous object, or a class object.
         * Your delegate is free to have as many additional non-matching methods as it likes.
         * It can even act as a delegate for multiple MetricsKit objects, though that is not recommended.
         *
         * "setDelegate()" may be called repeatedly, with the functions in the most-recently set delegates replacing any functions matching those in the earlier delegates, as well as any as-yet unreplaced functions.
         * This allows callers to use "canned" delegates to get most of their functionality, but still replace some number of methods that need custom implementations.
         * If, for example, a client wants to use the "canned" itml/environment delegate with the exception of, say, the "appVersion" method, they can set itml/environment as the delegate, and
         * then call "setDelegate()" again with their own delegate containing only a single method of "appVersion" as the delegate, which would leave all the other "replaced" methods intact,
         * but override the "appVersion" method again, this time with their own supplied delegate.
         *
         * NOTE: The delegate function will have a property called origFunction representing the original function that it replaced.
         * This allows the delegate to, essentially, call "super" before or after it does some work.
         * If a replaced method is overridden again with a subsequent "setDelegate()" call, the "origFunction" property will be the previous delegate's function.
         * @example:
         * To override one or more methods, in place:
         *      eventRecorder.setDelegate({recordEvent: itms.recordEvent});
         * To override one or more methods with a separate object:
         *      eventRecorder.setDelegate(eventRecorderDelegate);
         *      (where "eventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          var eventRecorderDelegate = {recordEvent: itms.recordEvent,
         *                                       sendMethod: 'itms'};
         * To override one or more methods with an instantiated object from a class definition:
         *      eventRecorder.setDelegate(new EventRecorderDelegate());
         *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          function EventRecorderDelegate() {
         *         }
         *         EventRecorderDelegate.prototype.recordEvent = itms.recordEvent;
         *         EventRecorderDelegate.prototype.sendMethod = function sendMethod() {
         *                                                          return 'itms';
         *                                                      };
         * To override one or more methods with a class object (with "static" methods):
         *      eventRecorder.setDelegate(EventRecorderDelegate);
         *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          function EventRecorderDelegate() {
         *         }
         *         EventRecorderDelegate.recordEvent = itms.recordEvent;
         *         EventRecorderDelegate.sendMethod = function sendMethod() {
         *                                                return 'itms';
         *                                            };
         * @param {Object} Object or Class with delegate method(s) to be called instead of default (built-in) methods.
         * @returns {Boolean} true if one or more methods on the delegate object match one or more methods on the default object,
         * otherwise returns false.
         */
        setDelegate: function setDelegate(delegate) {
            return attachDelegate(this, delegate);
        },

        localStorageObject: localStorageObject,
        sessionStorageObject: sessionStorageObject
    };

    /*
     *  src/network.js
     *  mt-client-config
     *
     *  Copyright © 2018 Apple Inc. All rights reserved.
     *
     */

    var attachDelegate$1 = mtMetricskitUtilsPrivate.reflect.attachDelegate;
    var makeAjaxRequest = mtMetricskitUtilsPrivate.network.makeAjaxRequest;

    /**
     * Network request methods exposed so delegate callers can override
     * @constructor
     */
    var network = {
        /**
         * Allows replacement of one or more of this class' functions
         * Any method on the passed-in object which matches a method that this class has will be called instead of the built-in class method.
         * To replace *all* methods of his class, simply have your delegate implement all the methods of this class
         * Your delegate can be a true object instance, an anonymous object, or a class object.
         * Your delegate is free to have as many additional non-matching methods as it likes.
         * It can even act as a delegate for multiple MetricsKit objects, though that is not recommended.
         *
         * "setDelegate()" may be called repeatedly, with the functions in the most-recently set delegates replacing any functions matching those in the earlier delegates, as well as any as-yet unreplaced functions.
         * This allows callers to use "canned" delegates to get most of their functionality, but still replace some number of methods that need custom implementations.
         * If, for example, a client wants to use the "canned" itml/environment delegate with the exception of, say, the "appVersion" method, they can set itml/environment as the delegate, and
         * then call "setDelegate()" again with their own delegate containing only a single method of "appVersion" as the delegate, which would leave all the other "replaced" methods intact,
         * but override the "appVersion" method again, this time with their own supplied delegate.
         *
         * NOTE: The delegate function will have a property called origFunction representing the original function that it replaced.
         * This allows the delegate to, essentially, call "super" before or after it does some work.
         * If a replaced method is overridden again with a subsequent "setDelegate()" call, the "origFunction" property will be the previous delegate's function.
         * @example:
         * To override one or more methods, in place:
         *      eventRecorder.setDelegate({recordEvent: itms.recordEvent});
         * To override one or more methods with a separate object:
         *      eventRecorder.setDelegate(eventRecorderDelegate);
         *      (where "eventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          var eventRecorderDelegate = {recordEvent: itms.recordEvent,
         *                                       sendMethod: 'itms'};
         * To override one or more methods with an instantiated object from a class definition:
         *      eventRecorder.setDelegate(new EventRecorderDelegate());
         *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          function EventRecorderDelegate() {
         *         }
         *         EventRecorderDelegate.prototype.recordEvent = itms.recordEvent;
         *         EventRecorderDelegate.prototype.sendMethod = function sendMethod() {
         *                                                          return 'itms';
         *                                                      };
         * To override one or more methods with a class object (with "static" methods):
         *      eventRecorder.setDelegate(EventRecorderDelegate);
         *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
         *          function EventRecorderDelegate() {
         *         }
         *         EventRecorderDelegate.recordEvent = itms.recordEvent;
         *         EventRecorderDelegate.sendMethod = function sendMethod() {
         *                                                return 'itms';
         *                                            };
         * @param {Object} Object or Class with delegate method(s) to be called instead of default (built-in) methods.
         * @returns {Boolean} true if one or more methods on the delegate object match one or more methods on the default object,
         * otherwise returns false.
         */
        setDelegate: function setDelegate(delegate) {
            return attachDelegate$1(this, delegate);
        },
        /**
         * Covers private utils implementation of makeAjaxRequest for delegation
         */
        makeAjaxRequest: makeAjaxRequest
    };

    /*
     *  src/config.js
     *  mt-client-config
     *
     *  Copyright © 2016-2017 Apple Inc. All rights reserved.
     *
     */

    var attachDelegate$2 = mtMetricskitUtilsPrivate.reflect.attachDelegate;
    var hasAnyKeys = mtMetricskitUtilsPrivate.reflect.hasAnyKeys;
    var isArray = mtMetricskitUtilsPrivate.reflect.isArray;
    var saveObjectToStorage = mtMetricskitUtilsPrivate.storage.saveObjectToStorage;
    var objectFromStorage = mtMetricskitUtilsPrivate.storage.objectFromStorage;
    var exponentialBackoff = mtMetricskitUtilsPrivate.backoff.exponentialBackoff;
    var valueForKeyPath = mtMetricskitUtilsPrivate.keyValue.valueForKeyPath;

    var NO_TOPIC_KEY = 'noTopicConfig';

    /**
     * The default config should not include keys which have meaning if they are omitted.
     * For example, a configSource without impressions means no impressions should be recorded, and in this case we should
     * not have impressions in defaults so we don't inadvertently disobey the client's configSource.
     */
    var DEFAULTS = {
        blacklistedFields: ['capacitySystem', 'capacitySystemAvailable', 'capacityDisk', 'capacityData', 'capacityDataAvailable'],
        compoundSeparator: '_',
        configBaseUrl: 'https://xp.apple.com/config/1/report',
        constraints: {
            profiles: {
                AMPWeb: {
                    precedenceOrderedRules: [
                        {
                            filters: 'any',
                            fieldConstraints: {
                                clientId: {
                                    generateValue: true,
                                    namespace: 'AMPWeb_isSignedOut',
                                    expirationPeriod: 86400000
                                }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    isSignedIn: [true]
                                }
                            },
                            fieldConstraints: {
                                clientId: {
                                    generateValue: true,
                                    namespace: 'AMPWeb_isSignedIn',
                                    expirationPeriod: 15552000000
                                }
                            }
                        }
                    ]
                },
                strict: {
                    precedenceOrderedRules: [
                        {
                            filters: 'any',
                            fieldConstraints: {
                                clientId: {
                                    generateValue: true,
                                    scopeFieldName: 'parentPageUrl',
                                    scopeStrategy: 'mainDomain',
                                    expirationPeriod: 86400000
                                },
                                consumerId: { blacklisted: true },
                                dsId: { blacklisted: true },
                                parentPageUrl: { scope: 'hostname' }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    eventType: ['click'],
                                    actionType: ['signUp']
                                }
                            },
                            fieldConstraints: {
                                parentPageUrl: { scope: 'fullWithoutParams' }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    eventType: ['dialog'],
                                    dialogType: ['upsell'],
                                    result: ['upsell']
                                }
                            },
                            fieldConstraints: {
                                parentPageUrl: { scope: 'fullWithoutParams' }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    userType: ['signedIn']
                                }
                            },
                            fieldConstraints: {
                                clientId: { scopeStrategy: 'all' }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    userType: ['signedIn'],
                                    eventType: ['click', 'dialog', 'media', 'search']
                                }
                            },
                            fieldConstraints: {
                                clientId: { blacklisted: true },
                                consumerId: { blacklisted: false },
                                dsId: { blacklisted: false }
                            }
                        },
                        {
                            filters: {
                                valueMatches: {
                                    userType: ['signedIn'],
                                    eventType: ['page', 'impressions']
                                },
                                nonEmptyFields: ['pageHistory']
                            },
                            fieldConstraints: {
                                clientId: { blacklisted: true },
                                consumerId: { blacklisted: false },
                                dsId: { blacklisted: false }
                            }
                        }
                    ]
                }
            }
        },
        fieldsMap: {
            cookies: ['itcCt', 'itscc'],
            custom: {
                impressions: ['id', 'adamId', 'link.type', 'station-hash'],
                location: ['id', 'adamId', 'dataSetId', 'name', 'fcKind', 'kindIds', 'type', 'link.type', 'station-hash', 'core-seed-name']
            },
            single: {
                targetId: ['id', 'adamId', 'contentId', 'type', 'link.type', 'fcId', 'userPreference', 'label', 'station-hash', 'linkIdentifier']
            }
        },
        metricsUrl: 'https://xp.apple.com/report',
        postFrequency: 60000,
        postFrequencyLowLatency: 5000,
        tokenSeparator: '|'
    };

    var _configs = {};

    /**
     * Appends the provided source and its subsection if the subsection key matches the provided topic to the provided configSources array.
     * @param {Array} configSources
     * @param {String} topic
     * @param {Object} source
     */
    var _appendSectionAndSubsectionToConfigSources = function _appendSectionAndSubsectionToConfigSources(configSources, topic, source) {
        if (source) {
            configSources.push(source);
            var subsection = source[topic];
            if (subsection && hasAnyKeys(subsection)) {
                configSources.push(subsection);
            }
        }
    };

    /**
     * Provides config-related functionality including managing config sources and values.
     * The functionality in this class is typically replaced via a delegate.
     * @see setDelegate
     * @delegatable
     * @constructor
     * @param {String} topic
     */
    var Config = function Config(topic) {
        // @private
        this._topic = topic;

        // @private
        this._debugSource = null;
        // @private
        this._cachedSource = null;
        // @private
        this._serviceSource = null;
        // @private
        this._initCalled = false;
        // @private
        this._initialized = false;
        // @private
        this._showedDebugWarning = false;
        // @private
        this._showedNoProvidedSourceWarning = false;
        // @private
        this._keyPathsThatSuppressWarning = {
            configBaseUrl: true // used to fetch a config source, so we do not expect sources to be set when retrieving this value
        };

        // @const
        this.DEBUG_SOURCE_KEY = 'mtClientConfig_debugSource' + DEFAULTS.compoundSeparator + this._topic;
        // @const
        this.CACHED_SOURCE_KEY = 'mtClientConfig_cachedSource' + DEFAULTS.compoundSeparator + this._topic;
    };

    /**
     * DEPRECATED - Use getConfig() and init() instead
     */
    Config.createConfig = function createConfig(topic, configSourcesFn, onSuccessHandler, onFailureHandler) {
        var returnConfig = Config.getConfig(topic);

        if (topic && topic !== NO_TOPIC_KEY // default config does not need to initialize
                  && !returnConfig._initCalled) {
            returnConfig.init(configSourcesFn, onSuccessHandler, onFailureHandler);
        }

        return returnConfig;
    };

    /**
     * Creates a new config instance associated with <topic>, unless it already exists, then returns it
     * @param {String} topic
     * @return {Config}
     */
    Config.getConfig = function getConfig(topic) {
        topic = topic || NO_TOPIC_KEY;
        var returnConfig = _configs[topic];

        if (!returnConfig) {
            returnConfig = new Config(topic);
            _configs[topic] = returnConfig;
        }

        return returnConfig;
    };

    /**
     * cleanup resources from the config of the provided topic and remove it from the config cache
     * @param {String} topic
     */
    Config.cleanupConfig = function cleanupConfig(topic) {
        if(topic && _configs[topic]) {
            var releasedConfig = _configs[topic];
            releasedConfig.setCachedSource();
            releasedConfig.setDebugSource();
            delete _configs[topic];
        }
    };

    /**
     * @return {Config} the default config instance, which is not associated with any topic
     */
    Config.defaultConfig = function defaultConfig() {
        return Config.getConfig();
    };

    /**
     * Returns the highest-precedence property value associated with keyPath
     * Tries to use the topic-specific config instance, and if it doesn't exist, uses the default config instance
     * @param {String} keyPath the dot-separated (".") path to the desired config value.
     * @param {String} (optional) topic
     * @returns {*} the value at the reached keypath. Returns "null" if the key or key's value is not found.
     * Values found in later (farthest in array) dictionaries of key/value pairs overwrite earlier dictionaries.
     * @see Config.prototype.value()
     */
    Config.value = function value(keyPath, topic) {
        var config = (topic && _configs[topic]) || Config.defaultConfig();

        return config.value.call(config, keyPath);
    };

    /**
     * Delegatable platform-specific environment and logger methods used by all config instances
     */
    Config.environment = environment;
    Config.logger = /*#__PURE__*/mtClientLoggerCore.loggerNamed('mt-client-config');
    Config.network = network;

    /**
     ************************************ PSEUDO-PRIVATE METHODS/IVARS ************************************
     * These functions need to be accessible for ease of testing, but should not be used by clients
     */
    Config.prototype._defaults = function _defaults() {
        return DEFAULTS;
    };

    Config.prototype._setInitialized = function _setInitialized(initialized) {
        this._initialized = initialized;
    };

    Config.prototype._setInitCalled = function _setInitCalled(initCalled) {
        this._initCalled = initCalled;
    };

    Config.prototype._setShowedDebugWarning = function _setShowedDebugWarning(value) {
        this._showedDebugWarning = value;
    };

    Config.prototype._setShowedNoProvidedSourceWarning = function _setShowedNoProvidedSourceWarning(value) {
        this._showedNoProvidedSourceWarning = value;
    };

    /**
     ************************************ PUBLIC METHODS ************************************
     */

    /**
     * Allows replacement of one or more of this class' functions
     * Any method on the passed-in object which matches a method that this class has will be called instead of the built-in class method.
     * To replace *all* methods of his class, simply have your delegate implement all the methods of this class
     * Your delegate can be a true object instance, an anonymous object, or a class object.
     * Your delegate is free to have as many additional non-matching methods as it likes.
     * It can even act as a delegate for multiple MetricsKit objects, though that is not recommended.
     *
     * "setDelegate()" may be called repeatedly, with the functions in the most-recently set delegates replacing any functions matching those in the earlier delegates, as well as any as-yet unreplaced functions.
     * This allows callers to use "canned" delegates to get most of their functionality, but still replace some number of methods that need custom implementations.
     * If, for example, a client wants to use the "canned" itml/environment delegate with the exception of, say, the "appVersion" method, they can set itml/environment as the delegate, and
     * then call "setDelegate()" again with their own delegate containing only a single method of "appVersion" as the delegate, which would leave all the other "replaced" methods intact,
     * but override the "appVersion" method again, this time with their own supplied delegate.
     *
     * NOTE: The delegate function will have a property called origFunction representing the original function that it replaced.
     * This allows the delegate to, essentially, call "super" before or after it does some work.
     * If a replaced method is overridden again with a subsequent "setDelegate()" call, the "origFunction" property will be the previous delegate's function.
     * @example:
     * To override one or more methods, in place:
     *      eventRecorder.setDelegate({recordEvent: itms.recordEvent});
     * To override one or more methods with a separate object:
     *      eventRecorder.setDelegate(eventRecorderDelegate);
     *      (where "eventRecorderDelegate" might be defined elsewhere as, e.g.:
     *          var eventRecorderDelegate = {recordEvent: itms.recordEvent,
     *                                       sendMethod: 'itms'};
     * To override one or more methods with an instantiated object from a class definition:
     *      eventRecorder.setDelegate(new EventRecorderDelegate());
     *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
     *          function EventRecorderDelegate() {
     *         }
     *         EventRecorderDelegate.prototype.recordEvent = itms.recordEvent;
     *         EventRecorderDelegate.prototype.sendMethod = function sendMethod() {
     *                                                          return 'itms';
     *                                                      };
     * To override one or more methods with a class object (with "static" methods):
     *      eventRecorder.setDelegate(EventRecorderDelegate);
     *      (where "EventRecorderDelegate" might be defined elsewhere as, e.g.:
     *          function EventRecorderDelegate() {
     *         }
     *         EventRecorderDelegate.recordEvent = itms.recordEvent;
     *         EventRecorderDelegate.sendMethod = function sendMethod() {
     *                                                return 'itms';
     *                                            };
     * @param {Object} Object or Class with delegate method(s) to be called instead of default (built-in) methods.
     * @returns {Boolean} true if one or more methods on the delegate object match one or more methods on the default object,
     * otherwise returns false.
     */
    Config.prototype.setDelegate = function setDelegate(delegate) {
        return attachDelegate$2(this, delegate);
    };

    /**
     * @return {String} the Figaro topic that this config corresponds with
     * Most clients do not need to override this method
     */
    Config.prototype.topic = function topic() {
        return this._topic;
    };

    /**
     * Returns the metrics config endpoint hostname
     * Most clients do not need to override this method
     * @return {String} a hostname e.g.xp.apple.com
     */
    Config.prototype.configHostname = function configHostname() { };

    /**
     * Returns a constructed URL to the metrics config endpoint for use with getConfig()
     * Most clients do not need to override this method
     * @return {String} a URL to the metrics config endpoint e.g. https://xp.apple.com/config/1/report/xp_its_main
     */
    Config.prototype.configUrl = function configUrl() {
        var configHostname = this.configHostname();
        var returnUrl;

        if (configHostname) {
            returnUrl = 'https://' + configHostname + '/config/1/report';
        } else {
            returnUrl = this.value('configBaseUrl');
        }

        if (this._topic !== NO_TOPIC_KEY) {
            returnUrl += '/' + this.topic();
        } else {
            Config.logger.error("config.configUrl(): Topic must be provided");
        }

        return returnUrl;
    };

     /**
      * This function will be used to access all of the sources for configuration data (e.g. disabled, blacklistedEvents, fieldsMap, etc.)
      * THIS METHOD MUST BE PROVIDED BY A DELEGATE
      * Returns an array of key/value objects (dictionaries) for all of the config sources (e.g. the bag, the page, the control parent, etc.).
      * This method will be called frequently and repeatedly from the metrics.config.* functions.
      * MetricsKit will use this return value to traverse the list of config objects, looking for config values.
      * If later dictionaries of key/value pairs contain any keys already collected, the most late (farthest in the area) config value will overwrite earlier ones.
      * IMPORTANT: This function might be called frequently and repeatedly so should be optimized for performance.
      *            It will be called frequently (rather than having this API provide a "setConfig" method for permanently setting the config values) since
      *            these config values can always be changing from one call to the next, so this ensures that they are current.
      * THEREFORE: This function should NOT try to "simplify" by, e.g., merging all config sources into a single object to return when called.
      *            Doing so is an enormous amount of work to do each time MetricsKit needs to look up a single value.
      *            It is far more efficient for MetricsKit to simply interogate each configSource for the required key, rather than
      *            the delegate function merging *all* keys of *all* sources (looping through all values of all sources) in order to look up a single value.
      * @example var sources = function() { return [itms.getBag().metrics, pageData.metrics.config]; };   // return an array of sources of app config
      * @example var sources = function() { return metrics.utils.keyValue.sourcesArray(itms.getBag().metrics, pageData.metrics.config, swooshData.metrics.config); }; // Let MetricsKit help build the array from a varargs list of sources
      * @example var sources = function() { return metrics.utils.keyValue.sourcesArray(existingArrayOfConfigSources, pageData.metrics.config, swooshData.metrics.config); }; // Let MetricsKit help build the array from a varargs list of sources where some args are already arrays of other sources (only works one level deep)
      * @see metrics.system.configSources.sources for simple creation of the return value of config sources.
      */
    Config.prototype.sources = function sources() { };

    /**
     * Search through the configuration sources provided by "metrics.system.configSources()", looking for the highest precedence value for "key"
     * If no config sources provided, look for values in the DEFAULTS constant
     * "keypath" can be a simple top-level config key such as "postFrequency" or a compound "path", such as fieldsMap.cookies
     * @param {String} keyPath the dot-separated (".") path to the desired config value.
     * @returns {Object} the value at the reached keypath. Returns "null" if the key or key's value is not found.
     * Values found in later (farthest in array) dictionaries of key/value pairs overwrite earlier dictionaries.
     * @see metrics.system.configSources.setDelegate()
     */
    Config.prototype.value = function value(keyPath) {
        var cachedSource = this.cachedSource();
        var serviceSource = this.serviceSource();
        var configSourcesArray = this.sources();
        var savedDebugSource = this.debugSource(); // NOTE: Always go through the accessor method, since it may need to be retrieved from localStorage
        var sourceProvided = (cachedSource || serviceSource || configSourcesArray || savedDebugSource);
        var sourcesToCheck;

        // show relevant warnings
        if (!configSourcesArray && !serviceSource && !(keyPath in this._keyPathsThatSuppressWarning)) {
            if(!this._showedNoProvidedSourceWarning) {
                this._showedNoProvidedSourceWarning = true;
                Config.logger.warn("Metrics config: No config provided via delegate or fetched via init(), using default/cached config values.");
            }
        }
        if (savedDebugSource) {
            if (!this._showedDebugWarning) {
                // We do this in case developers forget to clear this and wonder why the app isn't working correctly in normal running.
                this._showedDebugWarning = true;
                Config.logger.warn("\"debugSource\" found.\nThis will override any same-named client-supplied configSource fields.\nThis setting \"sticks\" across session, use \"setDebugSource(null)\" to clear");
            }
        }

        if (!isArray(configSourcesArray)) {
            configSourcesArray = [configSourcesArray];
        }

        // Use default blacklisting rules only if there are no provided sources
        if (keyPath.indexOf('blacklisted') === 0) {
            if (sourceProvided) {
                sourcesToCheck = [cachedSource, serviceSource, configSourcesArray, savedDebugSource];
            } else {
                sourcesToCheck = [DEFAULTS];
            }
        } else {
            // For non-blacklist rules, check all sources
            // Let "DEFAULTS" be overwritten by cachedSource, then serviceSource, then client-supplied configSources,
            // and then let "savedDebugSource" overwrite everyone
            sourcesToCheck = [DEFAULTS, cachedSource, serviceSource, configSourcesArray, savedDebugSource];
        }

        sourcesToCheck = this.configSourcesWithOverrides(sourcesToCheck, this.topic());
        // Pass each source as an individual argument; valueForKeyPath won't expand configSourcesArray if it is nested in sourcesToCheck
        return valueForKeyPath.apply(null, [keyPath].concat(sourcesToCheck));
    };

    /**
    * Pushes any subsections within a config source to the front of the provided config sources array if the subsection key matches with the specified topic.
    * This method is used by the default implementation of 'value(keyPath)' to determine precedence
    * of config sources for the given topic.
    * Subsections that are later in the array will take precedence over earlier subsections.
    * Note that if one of the config sources is an array, this method will traverse one level deep
    * to check for the presence of a dictionary that may contain a desired subsection.
    * We traverse one level deep to maintain parity with _utils.keyValue.valueForKeyPath() which will be used to traverse the config sources
    * @param {Array} configSources
    * @param {String} topic
    * @returns {Array} returnSources
    */
    Config.prototype.configSourcesWithOverrides = function configSourcesWithOverrides(configSources, topic) {
        var returnSources = configSources;
        if (configSources && configSources.length && topic) {
            returnSources = [];
            for (var i = 0; i < configSources.length; i++) {
                var source = configSources[i];
                if (source) {
                    if (isArray(source) && source.length) {
                        var subarray = [];
                        for (var j = 0; j < source.length; j++) {
                            _appendSectionAndSubsectionToConfigSources(subarray, topic, source[j]);
                        }
                        returnSources.push(subarray);
                    } else {
                        _appendSectionAndSubsectionToConfigSources(returnSources, topic, source);
                    }
                }
            }
        }
        return returnSources;
     };

    /**
     * Set's a "priority" configSource that will override any same-named client-supplied configSource fields.
     * This can be done in code (e.g. in testcases) or, more typically, in Web Inspector when debugging or testing a running app (client) using MetricsKit.
     * This is useful when testing, both in testcases and at runtime. One example would be to set a temporary "bag" structure that could then be tweaked at will, e.g. blacklisting fields, etc.
     * This setting "sticks" across session so that it can be set, the app restarted, and the values will be present at the earliest runnings of the app.
     * Use "setDebugSource(null)" to clear this value
     * NOTE: If no "localStorage" is available (e.g. when testing), this value will only last for the session or until it is explicitly cleared.
     * Here is an example of how to use this to test an app at runtime (and/or launch time)
     *      Run the app
     *      Open Web Inspector
     *      Set a variable to bag contents, e.g. var debugBag = itms.getBag();
     *      Call: metrics.config.setDebugSource(debugBag.metrics);
     *      enter: debugBag.metrics.disabled=true;
     *      Then do some things to generate events and make sure that:
     *          The app doesn’t crash
     *          No JavaScript events are generated in the console
     *          The events aren’t sent
     *      Reset that by entering: delete debugBag.metrics.disabled
     *      enter: debugBag.metrics.blacklistedEvents = [“page”, “click”];
     *      Then do some things to generate events and make sure that:
     *          The app doesn’t crash
     *          No JavaScript events are generated in the console
     *          Those events, and only those events, aren’t sent
     *      I save the object you set via metrics.config.setDebugSource to localStorage to facilitate testing at app startup, so remember to clear it out when you’re done or you’ll be confused why things aren’t working right in the future:
     *      metrics.config.setDebugSource();
     *      If there are values you want to be in effect at app-launch, just do the tweaking to the bag before your call to metrics.config.setDebugSource(debugBag.metrics);, passing in the tweaked bag.
     * @param aDebugSource a plain old JavaScript object with keys and values which will be searched when config is requested.
     * @returns {*} debugSource
     */
    Config.prototype.setDebugSource = function setDebugSource(aDebugSource) {
        this._debugSource = aDebugSource || null;
        return saveObjectToStorage(environment.localStorageObject(), this.DEBUG_SOURCE_KEY, this._debugSource);
    };

    /**
     * Return any previously set debugSource which would be stored in localStorage.
     * If not present in localStorage, the class variable value of debugSource will be returned.
     * @returns {*} debugSource
     */
    Config.prototype.debugSource = function debugSource() {
        if (this._debugSource) ; else {
            // Otherwise look in localStorage for one...
            this._debugSource = objectFromStorage(environment.localStorageObject(), this.DEBUG_SOURCE_KEY);
        }
        return this._debugSource;
    };

    /**
     * Save a source to localStorage which will have config values that can be used in the next visit until a fresh config is fetched
     * @param {Object} aSource
     * @return {Object}
     */
    Config.prototype.setCachedSource = function setCachedSource(aSource) {
        this._cachedSource = aSource || null;
        return saveObjectToStorage(environment.localStorageObject(), this.CACHED_SOURCE_KEY, this._cachedSource);
    };

    /**
     * Return any previously set savedSource which would be stored in localStorage.
     * The class variable value of savedSource will be returned if non-null to avoid expensive reads from disk.
     * @return {Object}
     */
    Config.prototype.cachedSource = function cachedSource() {
        if (this._cachedSource) ; else {
            // Otherwise look in localStorage for one...
            this._cachedSource = objectFromStorage(environment.localStorageObject(), this.CACHED_SOURCE_KEY);
        }
        return this._cachedSource;
    };

    /**
     * Set a source, typically one that was fetched from the config endpoint,
     * which will have config values that can be overwritten by clients via config.setDelegate
     * @param {Object} aServiceSource
     * @return {Object}
     */
    Config.prototype.setServiceSource = function setServiceSource(aServiceSource) {
        this._serviceSource = aServiceSource;
        return this._serviceSource;
    };

    /**
     * Returns a config source that was retrieved from the metrics config service endpoint
     * @return {Object}
     */
    Config.prototype.serviceSource = function serviceSource() {
        return this._serviceSource;
    };

    /**
     * Fetches a config payload from configUrl and stores it in _serviceSource
     * TODO: do not fetch config if it has already been fetched
     * TODO: allow callers to specify failure strategy
     * @param {String} configUrl
     * @param {Function} onSuccessHandler (optional) function to call on success
     * @param {Function} onFailureHandler (optional) function to call on failure
     */
    Config.prototype.fetchConfig = function fetchConfig(configUrl, onSuccessHandler, onFailureHandler) {
        onFailureHandler = onFailureHandler || function () { };

        var onSuccessWrapper = function onSuccessWrapper(response) {
            var validResponse;

            try {
                response = JSON.parse(response);
                validResponse = true;
            }
            catch (e) { // Fail if the response is invalid
                onFailureHandler.call(onFailureHandler, e);
            }

            // Don't wrap the whole successHandler in the try/catch
            if (validResponse && onSuccessHandler) {
                onSuccessHandler.call(onSuccessHandler, response);
            }
        };

        exponentialBackoff(network.makeAjaxRequest.bind(network, configUrl, 'GET', null), onSuccessWrapper, onFailureHandler);
    };

    /**
     * Initialize config by setting config delegate or fetching it from the config endpoint as necessary
     * If we wanted config to persist across page turns, we could save it via setCachedSource and fetch it every time we wake up,
     * but we expect most clients to be single page apps
     * @param {Function} (optional) configSourcesFn - a function that returns an array of key/value objects (dictionaries) for all of the config sources
     *                                                (e.g. the bag, the page, the control parent, etc.).
     * @param {Function} (optional) onSuccessHandler - function to execute on success; typically omitted if configSourcesFn was provided.
     * @param {Function} (optional) onFailureHandler - function to execute on failure
     */
    Config.prototype.init = function init(configSourcesFn, onSuccessHandler, onFailureHandler) {
        if (!this._initCalled) {
            this._initCalled = true;

            onSuccessHandler = onSuccessHandler || function () { };

            var onComplete = function onComplete() {
                this._initialized = true;
                onSuccessHandler.call(onSuccessHandler);
            }.bind(this);

            if (configSourcesFn) {
                this.setDelegate({
                    sources: configSourcesFn
                });
                onComplete();
            } else {
                // grab any previously cached config source to use while a new one is fetched
                this.setCachedSource(this.cachedSource());

                var configUrl = this.configUrl();
                var onConfigFetched = function onConfigFetched(configObject) {
                    this.setCachedSource(configObject);
                    this.setServiceSource(configObject);
                    onComplete();
                }.bind(this);

                this.fetchConfig(configUrl, onConfigFetched, onFailureHandler);
            }
        }
    };

    /**
     * DEPRECATED - Use init() instead
     */
    Config.prototype.initialize = function initialize(configSourcesFn, onSuccessHandler, onFailureHandler) {
        return this.init.apply(this, Array.prototype.slice.call(arguments));
    };

    /**
     * Indicates whether or not config has initialized.
     * Initialization is accomplished in one of the following ways:
     *     1) a service source is set via a call to config.setServiceSource()
     *     2) a source function delegate is set via config.setDelegate()
     * @return {Boolean}
     */
    Config.prototype.initialized = function initialized() {
        return this._initialized;
    };

    return Config;

})));
